function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgScheduledTask = function SvgScheduledTask(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22"
  }, props), /*#__PURE__*/React.createElement("g", {
    "data-name": "Scheduled box"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h22v22H0z",
    "data-name": "Rectangle 1510",
    style: {
      fill: "currentColor"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.647 513.733-2.79-2.833 1.066-1.082 1.728 1.754 3.986-4.047 1.066 1.082zm7.91-9.176v9.94a1.541 1.541 0 0 1-.441 1.081 1.494 1.494 0 0 1-1.065.448H8.506a1.494 1.494 0 0 1-1.065-.448A1.541 1.541 0 0 1 7 514.5v-9.94a1.54 1.54 0 0 1 .441-1.081 1.5 1.5 0 0 1 1.065-.448h.753V501.5h1.506v1.529h6.025V501.5h1.51v1.529h.753a1.5 1.5 0 0 1 1.065.448 1.54 1.54 0 0 1 .439 1.081zm-1.506 1.529H8.506v8.414h10.545z",
    "data-name": "Path 636",
    style: {
      fill: "#fff"
    },
    transform: "translate(-2.779 -497.764)"
  })));
};
export default SvgScheduledTask;